import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";
import { IExtractDocument } from "../interface/ExtractDocument/IExtractDocument";

enum ExtractDocumentBatchServiceEnum {
  demand = "/quote/export/extract/demand",
  capture = "/quote/export/extract/capture"
}

export default class ExtractDocumentBatchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/jobs");
  }

  public getAll = async (startDate: string, endDate: string): Promise<IExtractDocument[]> => await this.GET(`${ExtractDocumentBatchServiceEnum.capture}?startDate=${startDate}&endDate=${endDate}`);
  public requestProcess = async (data: any): Promise<IExtractDocument[]> => await this.POST(`${ExtractDocumentBatchServiceEnum.demand}`, data);

}


// WEBPACK FOOTER //
// ./src/services/api/ExtractDocumentBatch.service.ts